import Canvas from 'Scripts/classes/Canvas'
import { Pane } from 'tweakpane'
// import { GridHelper, AxesHelper } from 'ogl'

import Gradient from './Gradient'
import Stars from './Stars'
import Smoke from './Smoke'

export default class Particles extends Canvas {
  constructor({ canvas }) {
    super({ canvas })

    //Methods
    this.addGradient()
    this.addSmoke()
    this.addStars()
    // this.initPane()
    // this.addControls()
    // this.addHelper()

  }

  addGradient() {
    this.gradient = new Gradient({ gl: this.gl, scene: this.scene })
  }

  addStars() {
    this.stars = new Stars({ gl: this.gl, scene: this.scene, count: 1000 })
  }

  addSmoke() {
    this.smoke = new Smoke({ gl: this.gl, scene: this.scene, count: 2 })
  }

  initPane() {
    this.pane = new Pane()

    const f1 = this.pane.addFolder({
      title: 'Gradient',
    })

    const f2 = this.pane.addFolder({
      title: 'Smoke',
    })

    const f3 = this.pane.addFolder({
      title: 'Particles',
    })

    f1.addInput(
      this.gradient.mesh.program.uniforms.uRed,
      'value',
      { min: 0, max: 1, step: 0.001, label: 'Red' }
    )
    f1.addInput(
      this.gradient.mesh.program.uniforms.uGreen,
      'value',
      { min: 0, max: 1, step: 0.001, label: 'Green' }
    )
    f1.addInput(
      this.gradient.mesh.program.uniforms.uBlue,
      'value',
      { min: 0, max: 1, step: 0.001, label: 'Blue' }
    )

    // console.log(this.gradient.mesh.program.uniforms.uRed)

    f3.addInput(
      this.stars.mesh.program.uniforms.uSize,
      'value',
      { min: 0, max: 100, step: 1 }
    )

  }

  // addHelper() {
  //   const grid = new GridHelper(this.gl, { size: 10, divisions: 10 });
  //   grid.position.y = -0.001; // shift down a little to avoid z-fighting with axes helper
  //   grid.setParent(this.scene)

  //   const axes = new AxesHelper(this.gl, { size: 6, symmetric: true });
  //   axes.setParent(this.scene);

  // }


  onResize() {
    super.onResize()
    //Gradient
    this.gradient && this.gradient.onResize(this.viewport)
    //Stars
    this.stars && this.stars.onResize(this.viewport)
    //Smoke
    this.smoke && this.smoke.onResize(this.viewport)
  }

  update() {
    super.update()

    //Gradient
    this.gradient && this.gradient.update(this.time)
    //Stars
    this.stars && this.stars.update(this.time)
    //Smoke
    this.smoke && this.smoke.update(this.time)

  }


}